import type { Locale } from '@messenger/types'
import { LOCALE, LOCALE_DISPLAY_NAMES } from '@messenger/consts'

export const getLanguageDisplayName = (
  localeInput: Locale | string,
): (typeof LOCALE_DISPLAY_NAMES)[Locale] => {
  const invalidInput = !localeInput
  const resolvedLocaleInput = localeInput?.toUpperCase?.() as Locale
  const fallbackOutput = LOCALE_DISPLAY_NAMES[LOCALE.EN]
  if (invalidInput) return fallbackOutput

  const inputIsValidLocaleKey = resolvedLocaleInput in LOCALE_DISPLAY_NAMES
  if (inputIsValidLocaleKey) {
    const displayNameLocale = LOCALE_DISPLAY_NAMES[resolvedLocaleInput]
    if (!displayNameLocale) return fallbackOutput
    return displayNameLocale
  }

  return fallbackOutput
}
